import { FormulationAttributesOption } from './types';

export const productMarketingClaimOptions: FormulationAttributesOption[] = [
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:euEcolabel',
    value: 'eu-eco-label',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:rspoCertified',
    value: 'rspo-certified',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:bioBasedProduct',
    value: 'bio-based-product',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:nordicSwan',
    value: 'nordic-swan',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:euEcocert',
    value: 'eu-ecocert',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:lowCLP',
    value: 'low-clp',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:lowToZeroVOC',
    value: 'low-to-zero-voc',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:biodegradable',
    value: 'biodegradable',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:palmFree',
    value: 'palm-free',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:lowAllergens',
    value: 'low-allergens',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:highActive',
    value: 'high-active',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:nonLabelledForCLP',
    value: 'non-labelled-for-clp',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:mildToSkinAndEyes',
    value: 'mild-to-skin-and-eyes',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:easyToHandle',
    value: 'easy-to-handle',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:highlyEffectiveLowDosageLevels',
    value: 'highly-effective-low-dosage-levels',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:preservativeFree',
    value: 'preservativeFree',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:foodContact',
    value: 'halal',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:kosher',
    value: 'kosher',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noAnimalTesting',
    value: 'no-animal-testing',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:nanoparticlesFree',
    value: 'nanoparticles-free',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:lowSVHC',
    value: 'low-svhc',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:natural',
    value: 'natural',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:vegan',
    value: 'vegan',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noHeavyMetals',
    value: 'low-svhc',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:cleanLabel',
    value: 'clean-label',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:naturalColours',
    value: 'natural-colours',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:naturalFlavours',
    value: 'natural-flavours',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:glutenFree',
    value: 'gluten-free',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:allergenFree',
    value: 'allergen-free',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:palmFree',
    value: 'palm-free',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:nanoFree',
    value: 'nano-free',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noReducedFat',
    value: 'no-reduced-fat',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noReducedSugar',
    value: 'no-reduced-sugar',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noReducedSalt',
    value: 'no-reduced-salt',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sourceHighFiber',
    value: 'source-high-fiber',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sourceHighProtein',
    value: 'source-high-protein',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sourceHighVitaminsMinerals',
    value: 'source-high-vitamins-minerals',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:healthBenefices',
    value: 'health-benefices',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:veganVegetarianAnimalFree',
    value: 'vegan-vegetarian-animal-free',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:organic',
    value: 'organic',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:fairTrade',
    value: 'fair-trade',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:halal',
    value: 'halal',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:kosher',
    value: 'kosher',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:soothing',
    value: 'soothing',
    applications: {
      '*|PersonalCare': [
        'A_PC_006',
        'A_PC_006_001',
        'A_PC_006_002',
        'A_PC_006_003',
        'A_PC_006_004',
        'A_PC_006_005',
        'A_PC_006_006',
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:moisturising',
    value: 'moisturising',
    applications: {
      '*|PersonalCare': [
        'A_PC_006',
        'A_PC_006_001',
        'A_PC_006_002',
        'A_PC_006_003',
        'A_PC_006_004',
        'A_PC_006_005',
        'A_PC_006_006',
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care

        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover

        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants

        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp

        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory

        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene

        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sensitiveSkin',
    value: 'sensitive-skin',
    applications: {
      '*|PersonalCare': [
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care

        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:woundProtection',
    value: 'wound-protection',
    applications: {
      '*|PersonalCare': [
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:calming',
    value: 'calming',
    applications: {
      '*|PersonalCare': [
        'A_PC_006',
        'A_PC_006_001',
        'A_PC_006_002',
        'A_PC_006_003',
        'A_PC_006_004',
        'A_PC_006_005',
        'A_PC_006_006',

        'A_PC_005', // Color Cosmetics
        'A_PC_005_007', // Make-up Remover
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:waterSaving',
    value: 'water-saving',
    applications: {
      '*|PersonalCare': ['A_PC_006', 'A_PC_006_001', 'A_PC_006_002'],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiageing',
    value: 'antiageing',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:softFocus',
    value: 'soft-focus',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:wrinkleFilling',
    value: 'wrinkle-filling',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiCreasing',
    value: 'anti-creasing',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:longLasting',
    value: 'long-lasting',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_005', // Nail
        'A_PC_005_006', // Foundation

        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants

        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:easyToApply',
    value: 'easy-to-apply',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:quickDrying',
    value: 'quick-drying',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:waterProof',
    value: 'water-proof',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_004', // Eye
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:highCoverage',
    value: 'high-coverage',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:hydrating',
    value: 'hydrating',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:oilAbsorbing',
    value: 'oil-absorbing',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_002', // Powders
        'A_PC_005_003', // Pencils
        'A_PC_005_006', // Foundation
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:glossy',
    value: 'glossy',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:kissProof',
    value: 'kiss-proof',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:nonBleedingFeathering',
    value: 'non-bleeding/feathering',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:rubResistant',
    value: 'rub-resistant',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:removesWaterproof',
    value: 'removes-waterproof',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_007', // Make-up Remover
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:gentle',
    value: 'gentle',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_007', // Make-up Remover

        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory

        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:wearResistant',
    value: 'wear-resistant',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_005', // Nail
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:easyToRemove',
    value: 'easy-to-remove',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_005', // Nail
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:highGlossShine',
    value: 'high-gloss-shine',
    applications: {
      '*|PersonalCare': [
        'A_PC_005', // Color Cosmetics
        'A_PC_005_005', // Nail
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:dermatologicallyTested',
    value: 'dermatologically-tested',
    applications: {
      '*|PersonalCare': [
        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants

        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antibacterial',
    value: 'antibacterial',
    applications: {
      '*|PersonalCare': [
        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants

        'A_PC_003', // Skin Care
        'A_PC_003_007', // Facial Cleanser

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:forSensitiveSkin',
    value: 'for-sensitive-skin',
    applications: {
      '*|PersonalCare': [
        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:softening',
    value: 'softening',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_006', // Beard

        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:detangling',
    value: 'detangling',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:dryDamaged',
    value: 'dry-damaged',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:fineHair',
    value: 'fine-hair',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:colourProtection',
    value: 'colour-protection',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:colourEnhancing',
    value: 'colour-enhancing',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiDandruff',
    value: 'anti-dandruff',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_004', // Treatment
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:conditioning',
    value: 'conditioning',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sulphateFree',
    value: 'sulphate-free',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiBuildUp',
    value: 'anti-build-up',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:twoInOne',
    value: 'two-in-one',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:permanent',
    value: 'permanent',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:semiPermanent',
    value: 'semi-permanent',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:rootTouchUp',
    value: 'root-touch-up',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:temporary',
    value: 'temporary',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_007', // Bleaching
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:treatment',
    value: 'treatment',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_005', // Scalp
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:hairStrengthening',
    value: 'hair-strengthening',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_005', // Scalp
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:revitalising',
    value: 'revitalising',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_005', // Scalp

        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:exfoliating',
    value: 'exfoliating',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_005', // Scalp
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:strengthening',
    value: 'strengthening',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_004', // Treatment

        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_002', // Self Tan

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:damageRepair',
    value: 'damage-repair',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_004', // Treatment
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:thickening',
    value: 'thickening',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_004', // Treatment

        'A_PC_002', // Styling
        'A_PC_002_002', // Aerosol mousse
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:protection',
    value: 'protection',
    applications: {
      '*|PersonalCare': [
        'A_PC_001', // Hair
        'A_PC_001_004', // Treatment
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:protecting',
    value: 'protecting',
    applications: {
      '*|PersonalCare': [
        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory

        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene

        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:strongHold',
    value: 'strong-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_003', // Denture Adhesives
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:improvedComfort',
    value: 'improved-comfort',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_003', // Denture Adhesives
      ],
    },
  },
  // {
  //   name:
  //     'topics:formulation-attributes:options:availableProductMarketingClaims:foodseal',
  //   value: 'foodseal',
  //   applications: {
  //     '*|PersonalCare': [
  //       'A_PC_004', // Oral
  //       'A_PC_004_003', // Denture Adhesives
  //     ],
  //   },
  // },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:gumCare',
    value: 'gum-care',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:whitening',
    value: 'whitening',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:alcoholFree',
    value: 'alcohol-free',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:enamelCare',
    value: 'enamel-care',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sensitive',
    value: 'sensitive',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash

        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiseptic',
    value: 'antiseptic',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiBacterial',
    value: 'anti-bacterial',
    applications: {
      '*|PersonalCare': [
        'A_PC_004', // Oral
        'A_PC_004_001', // Toothpaste
        'A_PC_004_002', // Mouthwash
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiAgeing',
    value: 'anti-ageing',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip

        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_003', // After Sun
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antioxidant',
    value: 'antioxidant',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiPollution',
    value: 'anti-pollution',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:repair',
    value: 'repair',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip

        'A_PC_007', // Sun Care
        'A_PC_007_003', // After Sun
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:skinTightening',
    value: 'skin-tightening',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser

        'A_PC_007', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:illuminatingBrightning',
    value: 'illuminating/brightning',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_006', // Lip

        'A_PC_007', // Sun Care
        'A_PC_007_003', // After Sun
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:antiPuffinessDark',
    value: 'anti puffiness/-dark',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
      ],
    },
  },
  // {
  //   name:
  //     'topics:formulation-attributes:options:availableProductMarketingClaims:cycles',
  //   value: 'cycles',
  //   applications: {
  //     '*|PersonalCare': [
  //       'A_PC_003', // Skin Care
  //       'A_PC_003_001', // Eye
  //     ],
  //   },
  // },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:purifying',
    value: 'purifying',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_007', // Facial Cleanser

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:oilControl',
    value: 'oil-control',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_007', // Facial Cleanser

        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:cooling',
    value: 'cooling',
    applications: {
      '*|PersonalCare': [
        'A_PC_003', // Skin Care
        'A_PC_003_004', // Foot
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:extraFirmHold',
    value: 'extra-firm-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_002', // Aerosol mousse
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:firmHold',
    value: 'firm-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_002', // Aerosol mousse
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:lightHold',
    value: 'light-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_002', // Aerosol mousse
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:curlDefining',
    value: 'curl-defining',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_002', // Aerosol mousse
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:volumising',
    value: 'volumising',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_002', // Aerosol mousse
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:mediumHold',
    value: 'medium-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:flexibleHold',
    value: 'flexible-hold',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:shine',
    value: 'shine',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:weatherproof',
    value: 'weatherproof',
    applications: {
      '*|PersonalCare': [
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_002_003', // Aerosol spray
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:uvProtection',
    value: 'uv-protection',
    applications: {
      '*|PersonalCare': [
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:waterResistant',
    value: 'water-resistant',
    applications: {
      '*|PersonalCare': [
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:floral',
    value: 'floral',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:fougère',
    value: 'fougère',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:aromatic',
    value: 'aromatic',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:woody',
    value: 'woody',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:citrus',
    value: 'citrus',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:amber',
    value: 'amber',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:chypre',
    value: 'chypre',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:fruity',
    value: 'fruity',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:gourmand',
    value: 'gourmand',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:musk',
    value: 'musk',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:spicy',
    value: 'spicy',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:sweatReduction',
    value: 'sweat-reduction',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:odourProtection',
    value: 'odour-protection',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:aluminiumFree',
    value: 'aluminium-free',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:noWhitening',
    value: 'no-whitening',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:invisible',
    value: 'invisible',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:refreshing',
    value: 'refreshing',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableProductMarketingClaims:moisturizing',
    value: 'moisturizing',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
];
